import { useMemo } from 'react';
import { ComponentType } from 'react';
import { TemplateType_Slug } from '@weave/schema-gen-ts/dist/schemas/messaging/templator/v2/model.pb';
import { TemplateFlowTabItem } from '@frontend/integrated-messaging';
import { MessagingSelectInvoiceModal } from '@frontend/payments-collection-flow';
import { FormsTemplateModal } from '../components/forms-template-modal';
import { ScheduleTemplateModal } from '../components/schedule-template-modal';
import { useTemplateMessagingStore } from '../stores/template-selector-store';

type TemplateTypeModalConfig = {
  Component: ComponentType<any>;
  data?: TemplateFlowTabItem;
  additionalProps?: Record<string, any>;
};

export const useTemplateTypeModalMap = (
  tabItemMap: Record<string, TemplateFlowTabItem | undefined>
): Partial<Record<TemplateType_Slug, TemplateTypeModalConfig>> => {
  const { selectedMessageTemplate } = useTemplateMessagingStore('selectedMessageTemplate');
  return useMemo(
    () => ({
      [TemplateType_Slug.MANUAL_FORMS_MESSAGE]: {
        Component: FormsTemplateModal,
        data: tabItemMap['Forms'],
      },
      [TemplateType_Slug.MANUAL_APPOINTMENT_REMINDER]: {
        Component: ScheduleTemplateModal,
        data: tabItemMap['Schedule'],
      },
      [TemplateType_Slug.MANUAL_PAYMENT_REQUEST]: {
        Component: MessagingSelectInvoiceModal,
        data: tabItemMap['Payments'],
        additionalProps: {
          selectedMessageTemplate: selectedMessageTemplate,
        },
      },
    }),
    [tabItemMap, selectedMessageTemplate]
  );
};
